import React__default, { useMemo } from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { ThemeProvider, MobileThemeProvider, MobileMode } from '@amzn/storm-ui';
import { a as addFeedbackFormTheme } from './addFeedbackFormTheme-BKv0OWWq.js';

const FeedbackFormThemeProvider = ({
  children,
  theme,
  isMobile
}) => {
  const themeIncludesFeedbackform = useMemo(() => addFeedbackFormTheme(theme), [theme]);
  let mobileMode = MobileMode.Auto;
  if (typeof isMobile === 'boolean') {
    mobileMode = isMobile ? MobileMode.Enable : MobileMode.Disable;
  }
  return /*#__PURE__*/React__default.createElement(ThemeProvider, null, /*#__PURE__*/React__default.createElement(MobileThemeProvider, {
    mobileMode: mobileMode
  }, /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: themeIncludesFeedbackform
  }, children)));
};

export { FeedbackFormThemeProvider as F };
//# sourceMappingURL=FeedbackFormThemeProvider-BtQQn72x.js.map
